import type { ServiceType } from '@web/types';

type BillableRateValue = ServiceType['billable_rate'];

export function getBillableRateAmount(
  billableRate: BillableRateValue,
): number | null {
  if (billableRate === null || billableRate === undefined) {
    return null;
  }

  if (typeof billableRate === 'number') {
    return Number.isNaN(billableRate) ? null : billableRate;
  }

  const quantity = Number(billableRate.quantity);
  return Number.isNaN(quantity) ? null : quantity;
}

export function getBillableRateCurrencyCode(
  billableRate: BillableRateValue,
): string {
  if (
    billableRate &&
    typeof billableRate === 'object' &&
    billableRate.currency?.code
  ) {
    return billableRate.currency.code;
  }

  if (
    billableRate &&
    typeof billableRate === 'object' &&
    billableRate.currency_code
  ) {
    return billableRate.currency_code;
  }

  return 'USD';
}

export function formatBillableRateValue(
  billableRate: BillableRateValue,
): string {
  const amount = getBillableRateAmount(billableRate) ?? 0;
  const currencyCode = getBillableRateCurrencyCode(billableRate);

  const formatConfig: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
  };

  try {
    return new Intl.NumberFormat('en-US', formatConfig).format(amount);
  } catch {
    return new Intl.NumberFormat('en-US', {
      ...formatConfig,
      currency: 'USD',
    }).format(amount);
  }
}
